export default __webpack_public_path__ + "static/media/lumoz-light-logo.9bf522c8.svg";